import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../modules/infra/i18n';

import CardInput from '../CardInput';
import PaymentCardIcon from '../PaymentCardIcon';

const PaymentCard = ({
  canModifyPaymentCard,
  card,
  changeCard,
  removeCard,
  buttonText,
  disabled,
  currency,
  paymentCustomerChangeRequired,
  wrapperClassName,
  useInputDisplayStyle,
  description,
}) => (
  <div className={wrapperClassName}>
    <p display-if={paymentCustomerChangeRequired} className="u-co-red u-type--semibold u-fontsize-extrasmall u-mb">
      {t('common:payment_card.subscription_reenter_message', { currency: currency.toUpperCase() })}
    </p>
    <p display-if={description} className="u-mb- c-heading c-heading--small">
      {description}
    </p>
    <div display-if={card}>
      <div display-if={useInputDisplayStyle} className="c-label-new u-mb--">
        {t('common:payment_card.credit_debit_card_label')}
      </div>
      <div className="u-type--semibold o-flexbox o-flexbox--content-align-center">
        <div className="u-mr c-payment-method" display-if={useInputDisplayStyle}>
          <PaymentCardIcon cardBrand={card.brand} className="c-payment-method--icon" />
          <span className="u-ml--">{t('common:payment_card.pay_using_card', { brand: card.brand, last4: card.last4 })}</span>
        </div>
        <span className="u-mr" display-if={!useInputDisplayStyle}>{t('common:payment_card.pay_using_card_with_period', { brand: card.brand, last4: card.last4 })}</span>

        <button
          className="c-btn c-btn--medium"
          disabled={disabled}
          display-if={canModifyPaymentCard}
          onClick={removeCard}
          type="button"
        >
          {t('common:payment_card.change_button')}
        </button>
      </div>
    </div>
    <CardInput onSubmit={changeCard} buttonText={buttonText} display-if={!card} disabled={disabled} />
  </div>
);
PaymentCard.propTypes = {
  canModifyPaymentCard: PropTypes.bool.isRequired,
  card: PropTypes.shape({
    brand: PropTypes.string,
    last4: PropTypes.string,
  }),
  removeCard: PropTypes.func,
  changeCard: PropTypes.func,
  buttonText: PropTypes.string,
  currency: PropTypes.string.isRequired,
  paymentCustomerChangeRequired: PropTypes.bool,
  disabled: PropTypes.bool,
  wrapperClassName: PropTypes.string,
  useInputDisplayStyle: PropTypes.bool,
  description: PropTypes.string,
};
PaymentCard.defaultProps = {
  wrapperClassName: '',
  card: null,
  removeCard: () => null,
  changeCard: () => null,
  buttonText: null,
  disabled: false,
  paymentCustomerChangeRequired: false,
  useInputDisplayStyle: false,
  description: null,
};

export default PaymentCard;
